module.exports = __webpack_public_path__ + "img/saudia-5.d04bcbfc.png";